import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetRecordTypeQuery } from '@platform/state/api';
import { routes } from '@platform/core/lib/routes';
import type { IRefOpenLinkProps } from './IRefOpenLinkProps';

/** « · Відкрити ↗» у підписі поля-посилання з вибраним записом (прототип f.hasRef): веде на сторінку запису в модулі цільового типу. */
export function RefOpenLink({ field, recordId }: IRefOpenLinkProps) {
  const { t } = useTranslation();
  const target = field.ref ?? '';
  const { data } = useGetRecordTypeQuery(target, { skip: !target });
  const moduleKey = data?.module.module.key;
  if (!moduleKey) return null;
  return (
    <>
      <span aria-hidden> · </span>
      <Link className="fc-open" to={routes.record(moduleKey, target, recordId)}>{t('fieldControls.open')}</Link>
    </>
  );
}
